/* @flow */
import GroupRemoveFromOrgModal from './GroupRemoveFromOrgModal';

export default GroupRemoveFromOrgModal;
